import { render, staticRenderFns } from "./AdminVolunteerReports.vue?vue&type=template&id=0925097a&scoped=true&"
import script from "./AdminVolunteerReports.vue?vue&type=script&lang=js&"
export * from "./AdminVolunteerReports.vue?vue&type=script&lang=js&"
import style0 from "./AdminVolunteerReports.vue?vue&type=style&index=0&id=0925097a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0925097a",
  null
  
)

export default component.exports